import { BUSINESS_URL, END_USER_URL } from '../../../config';
import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { Box, CardMedia, Divider, MenuItem, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import i18next from "i18next";
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";
import { ReactComponent as Logo } from './../../../assets/logos/LogoWhite.svg';
// import { ReactComponent as LogoText } from './../../../assets/logos/LogoTextWhite.svg';
import { useEffect, useState } from "react";
import ModelCopeLink from './../../global/ModelCopeLink';
import ModelQrCode from './../../global/ModelQrCode';
import { ReactComponent as CopyIcon } from './../../../assets/icons/copyLink.svg';
import { ReactComponent as Qr } from './../../../assets/icons/qrCode.svg';
import { ReactComponent as Reating } from './../../../assets/icons/Reating.svg';
import { ReactComponent as Correspondence } from './../../../assets/icons/Correspondence.svg';
import Btn from "../../global/Btn";
import ShareButton from "../../global/Share/ShareButton";
import { shareWithNativeOrPopup } from "../../../utils/nativeShare";
import { useSendStoreLogs } from "../../../hooks/StoreLogs/useSendStoreLogs";

export default function NavDrawer({ setDrawer, drawer, data, slug }) {

    const handleClose = () => setDrawer(false);
    const location = useLocation();

    useEffect(() => {
        handleClose();
    }, [location.pathname]);

    useEffect(() => {
        return () => handleClose();
    }, []);

    let lng = i18next.language
    const { storeLogs: sendLogs } = useSendStoreLogs();
    const [openCopeLink, setOpenCopeLink] = useState(false);
    const handleClickOpenCopeLink = () => setOpenCopeLink(true);
    const [openQr, setOpenQr] = useState(false);
    const handleClickOpenQr = () => {
        setOpenQr(true);
    };
    const fallUrl = `${END_USER_URL}/${slug}`
    const [shareAnchorEl, setShareAnchorEl] = useState(null);
    const shareOpen = Boolean(shareAnchorEl);

    const handleShareOpen = async (event) => {
        event.stopPropagation();
        if (shareOpen) {
            setShareAnchorEl(null);
            return;
        }
        const result = await shareWithNativeOrPopup({
            name: data?.name,
            url: fallUrl,
            openPopup: () => setShareAnchorEl(event.currentTarget),
        });
        if (result === 'shared') sendLogs('shares');
    };

    const handleShareClose = () => {
        setShareAnchorEl(null);
        // setDrawer(false)
    };
    // const shareQRCodeDirect = () => {
    //     sendLogs('shares')
    //     const qrUrl = `https://wa.me/?text=${encodeURIComponent(fallUrl)}`;
    //     window.open(qrUrl, '_blank');
    // };
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const backToHome = () => {
        setDrawer(false);
        navigate(`/${slug}`);
    }
    return (
        <div>
            <React.Fragment>
                <Drawer
                    anchor={lng === 'en' ? 'left' : 'right'}
                    open={drawer}
                    onClose={() => setDrawer(false)}
                    sx={{
                        '.MuiDrawer-paper': {
                            height: '85% !important',
                            overflowY: 'auto',
                            backgroundColor: 'rgb(32,32,32, 90%)',
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: 350,
                            gap: 1,
                            display: "flex",
                            flexDirection: "column",
                            textAlign: lng === 'en' ? 'left' : 'right',
                            padding: "40px 20px",
                            position: 'relative'
                        }}>
                        <Box
                            sx={{
                                flexGrow: 0,
                                display: { md: "flex", xs: "flex" },
                                justifyContent: "center",
                                width: "100%",
                                alignItems: "center",
                            }}>
                            <IconButton onClick={() => setDrawer(false)} sx={{ position: 'absolute', top: '5px', right: '5px', color: '#fff' }}>
                                <CloseIcon />
                            </IconButton>
                            <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', cursor: 'pointer' }} onClick={() => backToHome()}>
                                <CardMedia component={'img'} alt="logo" src={data?.logo} sx={{ width: '75px', height: '75px', borderRadius: '50%' }} />
                                <Typography color={'primary.text'} variant="body1" fontWeight={'bold'}>
                                    {data?.name}
                                </Typography>
                                <Typography textAlign={'center'} color={'primary.text'} variant="body2">
                                    {data?.category?.name}
                                </Typography>
                            </Box>
                        </Box>
                        {/* <Divider sx={{ mt: 1}} /> */}
                        <MenuItem onClick={handleClose} >
                            <IconButton
                                onClick={handleClickOpenCopeLink}
                                className="link"
                                sx={{ flexDirection: 'row', gap: 2 }}
                            >
                                <CopyIcon className={'svg'} />
                                <Typography color={'primary.text'} sx={{ fontWeight: 'medium', fontFamily: 'URW DIN Arabic', fontSize: 14 }} >
                                    {lng === 'ar' ? 'نسخ الرابط' : 'Share Link'}
                                </Typography>
                            </IconButton>
                        </MenuItem>
                        <MenuItem onClick={handleClose} >
                            <IconButton
                                onClick={handleClickOpenQr}
                                className="link"
                                sx={{ flexDirection: 'row', gap: 2 }}
                            >
                                <Qr className={'svg'} />
                                <Typography color={'primary.text'} sx={{ fontWeight: 'medium', fontFamily: 'URW DIN Arabic', fontSize: 14 }}>
                                    {lng === 'ar' ? 'رمز Qr' : 'Qr Code'}
                                </Typography>
                            </IconButton>
                        </MenuItem>
                        <MenuItem
                            onClick={(e) => handleShareOpen(e)}
                            sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                        >
                            <ShareButton
                                sx={{ flexDirection: 'row', gap: 2 }}
                                main_url={fallUrl}
                                name={data?.name}
                                anchorEl={shareAnchorEl}
                                open={shareOpen}
                                onOpen={(e) => setShareAnchorEl(e.currentTarget)}
                                onClose={() => handleShareClose()}
                            />
                            <Typography color={'primary.text'} sx={{ fontWeight: 'medium', fontFamily: 'URW DIN Arabic', fontSize: 14 }}>
                                {lng === 'ar' ? 'مشاركة' : 'share'}
                            </Typography>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                            <IconButton
                                onClick={() => navigate(`/${slug}/add-review`)}
                                className="link"
                                sx={{ flexDirection: 'row', gap: 2 }}
                            >
                                <Reating className={'svg'} />
                                <Typography color={'primary.text'} sx={{ fontWeight: 'medium', fontFamily: 'URW DIN Arabic', fontSize: 14 }} >
                                    {lng === 'ar' ? 'تقييم' : 'evaluation'}
                                </Typography>
                            </IconButton>
                        </MenuItem>
                        <MenuItem onClick={handleClose} >
                            <IconButton
                                onClick={() => navigate(`/${slug}/correspondence`)}
                                className="link"
                                sx={{ flexDirection: 'row', gap: 2 }}
                            >
                                <Correspondence className={'svg'} />
                                <Typography color={'primary.text'} sx={{ fontWeight: 'medium', fontFamily: 'URW DIN Arabic', fontSize: 14 }} >
                                    {lng === 'ar' ? 'المراسلة' : 'Correspondence'}
                                </Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 1, borderColor: theme => theme.palette.primary.text }} />
                        <Box component={Link}
                            target='_blank'
                            to={`${BUSINESS_URL}/register/vendor?lng=${i18n.language}`}
                            sx={{ width: 'fit-content', m: 'auto' }}>
                            <Btn width='fit-content' sx={{
                                background: theme => theme.palette.background.date, 
                                height: '35px',
                                color: theme => theme.palette.primary.default
                            }}>
                                <Typography color={'primary.default'} variant='body1'>
                                    {lng === 'ar'?'قم بإنشاء تطبيق علامتك التجارية':'Create your brand app'}
                                    {/* {t("createYourStore")} */}
                                </Typography>
                            </Btn>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, mt: 4 }}
                            onClick={() => backToHome()}>
                            <Typography variant="caption" color={"primary.text"}
                                sx={{ fontWeight: 'light', fontFamily: 'URW DIN Arabic', fontSize: 14 }}>{lng === 'ar' ? 'بواسطة' : "By"}</Typography>
                            <Logo style={{ width: '50px', height: 'auto' }} />
                            <Typography
                                color={'primary.text'}
                                // variant={isMobile ? 'h6' : 'h5'}
                                sx={{ fontFamily: 'URW DIN Arabic', fontSize: 14, fontWeight: 'light' }}
                            >
                                {t("navbar.title")}
                            </Typography>
                            {/* <LogoText style={{ width: '100px' }} /> */}
                        </Box>
                    </Box>
                </Drawer>
            </React.Fragment>
            <ModelCopeLink openDialog={openCopeLink}
                setOpenDialog={setOpenCopeLink} slug={slug} />
            <ModelQrCode openDialog={openQr}
                setOpenDialog={setOpenQr} data={data} slug={slug} />
        </div>
    );
}
